import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ConstantContact from './icon-constant-contact.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ConstantContact {...validProps} />;
}
SvgComponent.iconName = 'constantContact';

/**
 * @deprecated This is a legacy icon
 */
export const ConstantContactIcon = svgIconWrapper(SvgComponent);
